export default "__VITE_ASSET__C5o2Pbgx__"